import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import ProjectDetailsBackground from '../../assets/images/ProjectDetailsBackground.jpeg';
import { myProjectsData } from '../../data';

const ProjectDetails = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const { id } = useParams();

    const project = myProjectsData.find(project => project.id === +id);

    const { name, images, liveLink, gitClient, description, gitServer, technologies, time } = project;

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
    };

    return (
        <main className='text-white min-h-screen mb-96 sm:mb-0 overflow-hidden'>
            <div data-aos="fade" data-aos-duration="1500" className='bg-[rgba(46,46,46,0)] pb-6 mb-20 xl:mb-0'>
                <div className='flex flex-col items-center sm:border-b-[1px] border-green-600 sm:shadow-green-900'>
                    <div className='w-full grid grid-cols-1 xl:grid-cols-12'>
                        <section className='col-span-6 bg-black'>
                            <h2 className='py-[2px] md:py-2 px-5 text-center xl:text-right w-full text-lg md:text-2xl font-play text-green-500 capitalize border-b-[1px] border-green-600'> {name}</h2>
                            <Carousel
                                className='w-full '
                                responsive={responsive}
                                ssr={true}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={3000}
                                keyBoardControl={true}
                                removeArrowOnDeviceType={["mobile"]}
                            >
                                <img src={images[0]} alt="" />
                                <img src={images[1]} alt="" />
                                <img src={images[2]} alt="" />
                                <img src={images[3]} alt="" />
                                <img src={images[4]} alt="" />
                                <img src={images[5]} alt="" />
                            </Carousel>
                        </section>

                        <section className='col-span-6 relative'>
                            <div className='overflow-hidden w-full h-full hidden sm:block  '>
                                <img className='w-full opacity-20 h-full' style={{ filter: 'blur(8px)' }} src={ProjectDetailsBackground} alt="" />
                            </div>
                            <div className='absolute top-0 left-0 w-full'>
                                <h2 className='py-[2px] md:py-2 px-5 bg-black  text-center xl:text-right w-full text-lg md:text-2xl font-play text-green-500 capitalize'>Information</h2>
                                <hr className='border-green-700' />
                                <div className='pl-3 sm:pl-5'>
                                    <div className="my-3 sm:my-4">
                                        <p className='text-lg sm:text-xl font-play text-green-500'>Technologies: </p>
                                        <span className='font-Cormorant-Garamond text-sm md:text-[16px]'>{technologies}</span>
                                    </div>
                                    <div>
                                        <p className='text-lg sm:text-xl font-play text-green-500'>Features: </p>
                                        <ul className='ml-5 font-Cormorant-Garamond text-sm md:text-[16px]'>
                                            {description.map((des, i) => <li key={i}>{i + 1}. {des}</li>)}
                                        </ul>
                                    </div>
                                    <p className="my-3">
                                        <span className='text-lg sm:text-xl font-play text-green-500'>Development Period:</span>
                                        <span className='font-Cormorant-Garamond text-sm md:text-[16px]'> {time}</span>
                                    </p>
                                    <div className='col-span-2 text-left font-play'>
                                        <div className='flex flex-wrap justify-between mr-3 sm:mr-5 max-w-2xl'>
                                            <a target='blank' href={`${liveLink}`}>
                                                <button className='mb-1 mt-2 btn btn-sm capitalize w-40 sm:w-48 h-9 font-play font-light rounded text-xs sm:text-sm text-green-400 hover:text-white bg-[#00283a80] hover:bg-green-600 transition duration-150 ease-in-out peer-hover:text-4xl border-[1px] border-green-900'>
                                                    <p>Live Preview</p>
                                                    <FontAwesomeIcon className='h-4 ml-3' icon={faArrowRight} />
                                                </button>
                                            </a>
                                            <a target='blank' href={`${gitClient}`}>
                                                <button className='mb-1 mt-2 btn btn-sm capitalize w-40 sm:w-48 h-9 font-play font-light rounded text-xs sm:text-sm text-green-400 hover:text-white bg-[#00283a80] hover:bg-green-600 transition duration-150 ease-in-out peer-hover:text-4xl border-[1px] border-green-900'>
                                                    <FontAwesomeIcon className='h-4 mr-3' icon={faGithub} />
                                                    <p>Client-side</p>
                                                </button>
                                            </a>
                                            {
                                                gitServer && <a target='blank' href={`${gitServer}`}>
                                                    <button className='mb-1 mt-2 btn btn-sm capitalize w-40 sm:w-48 h-9 font-play font-light rounded text-xs sm:text-sm text-green-400 hover:text-white bg-[#00283a80] hover:bg-green-600 transition duration-150 ease-in-out peer-hover:text-4xl border-[1px] border-green-900'>
                                                        <FontAwesomeIcon className='h-4 mr-3' icon={faGithub} />
                                                        <p>Server-Side</p>
                                                    </button>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ProjectDetails;